// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9c04e0c","455":"bf9d83c0","977":"3cf60997"}[chunkId] + ".chunk.js";
};